export default __webpack_public_path__ + "static/media/purple-candy.ae25b8a5.png";